var Theme = {};

const BREAKPOINT_LARGEDESKTOP = 1800;
const BREAKPOINT_MEDIUMDESKTOP = 1500;
const BREAKPOINT_DESKTOP = 1360;
const BREAKPOINT_LAPTOP = 1200;
const BREAKPOINT_TABLETHOR = 1024;
const BREAKPOINT_TABLET = 768;
const BREAKPOINT_PHABLET = 576;
const BREAKPOINT_MOBILE = 325;

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.Theme = {};

  /**
   * Constructeur
   */
  Theme.Common = function () {
    // Éléments
    this.elements = {
      htmlBody: $("html, body"),
      body: $("body"),
      page: $("#page"),
    };

    this.elements.externalLinks = this.elements.page.find('a[href^="http"]');
    this.elements.openInNewWindowLinks =
      this.elements.page.find('a[href$=".pdf"]');

    // Variables
    this.menuScrollOffset = 110;
    this.langcode = drupalSettings.path.currentLanguage || "fr";

    return this;
  };

  /**
   * Méthodes
   */
  Theme.Common.prototype = {
    load: function (className, options) {
      if (Theme[className] !== undefined) {
        return new Theme[className](this, options);
      } else {
        console.error('Class "Theme.' + className + '" not found.');
      }
    },
    autoload: function (options) {
      var self = this;

      if (options !== undefined) {
        $.each(options, function (className, condition) {
          if (self.elements.body.is(condition)) {
            return self.load(className).init();
          }
        });
      } else {
        console.error("Options is undefined.");
      }
    },

    /**
     * Init common
     */
    init: function () {
      this.cookieTarteAuCitronHandler();
      this.externalLinksHandler();
      this.openInNewWindowHandler();
      this.anchorLinksHandler();
    },

    /**
     * Gestionnaire de CookieNotice
     */
    cookieTarteAuCitronHandler: function () {
      var gtmGoogle = drupalSettings.GTMcookie;
      tarteaucitron.init({
        hashtag:
          "#tarteaucitron" /* Ouverture automatique du panel avec le hashtag */,
        highPrivacy: true /* désactiver le consentement implicite (en naviguant) ? */,
        AcceptAllCta: true,
        orientation:
          "middle" /* le bandeau doit être en haut (top) ou en bas (bottom) ? */,
        adblocker: false /* Afficher un message si un adblocker est détecté */,
        showAlertSmall: false /* afficher le petit bandeau en bas à droite ? */,
        cookieslist: true /* Afficher la liste des cookies installés ? */,
        removeCredit: true /* supprimer le lien vers la source ? */,
        useExternalCss: true,
        showIcon: false,
      });

      if (gtmGoogle !== "" && gtmGoogle !== null) {
        tarteaucitron.user.googletagmanagerId = gtmGoogle;
        (tarteaucitron.job = tarteaucitron.job || []).push("googletagmanager");
      }
      (tarteaucitron.job = tarteaucitron.job || []).push("youtube");
      //(tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
      //(tarteaucitron.job = tarteaucitron.job || []).push('dailymotion');

      // lien pour ouvir le gestionnaire de cookies
      $(".link-cookies").on("click touch", function (e) {
        e.preventDefault();
        tarteaucitron.userInterface.openPanel();
      });
    },

    /**
     * Gestionnaire des liens externes
     */
    externalLinksHandler: function () {
      if (this.elements.externalLinks.length) {
        this.elements.externalLinks.each(function (i, link) {
          link = $(link);

          if (link.attr("href").indexOf(window.location.host) === -1) {
            link.attr("target", "_blank");
          }
        });
      }
    },

    /**
     * Gestionnaire pour l'ouverture de lien dans un nouvel onglet
     */
    openInNewWindowHandler: function () {
      if (this.elements.openInNewWindowLinks.length) {
        this.elements.openInNewWindowLinks.on("click", function (event) {
          event.preventDefault();
          window.open($(event.currentTarget).attr("href"));
        });
      }
    },

    /**
     * Gestionnaire des ancres
     */
    anchorLinksHandler: function () {
      var self = this;

      self.elements.page.on(
        "click",
        'a[href*="#"]:not([href="#"])',
        function (event) {
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            var target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");

            if (target.length) {
              event.preventDefault();

              self.scrollTop(target.offset().top);
            }
          }
        }
      );
    },

    /**
     * Scroll top
     *
     * @param offset
     * @param speed
     */
    scrollTop: function (offset, speed) {
      speed = speed || 500;

      this.elements.htmlBody.animate(
        {
          scrollTop: offset - this.menuScrollOffset,
        },
        speed
      );

      return this;
    },
  };

  /**
   * Load Themes
   * @type {{attach: attach, detach: detach}}
   */
  Drupal.behaviors.drupTheme = {
    attach: function (context) {
      if (context.body !== undefined) {

        $(once('drupTheme', context === document ? 'html' : context)).each(function () {
          Drupal.Theme = new Theme.Common();
          Drupal.Theme.init();
          Drupal.Theme.load('all').init();
        });
        // Drupal.Theme.autoload({
        //     front: '.is-front'
        // });
      }
      // vue actualisée en ajax : rappel du lazyload
      else if (
        $(context).hasClass("view-display-list-news") ||
        $(context).hasClass("view-display-list-projects") ||
        $(context).hasClass("view-display-list-press")
      ) {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.load("all").initLazyLoad();
        Drupal.Theme.load("all").initForm();
      }

      if ($(".webform-submission-contact-form div[role='alert']")[0]) {
        $(".webform-submission-contact-form").toggleClass("active");
      }
    },
  };
})(jQuery, Drupal, drupalSettings);
